<template>
  <v-menu
    v-model="dateMenu"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="290px"
    v-bind="$attrs"
    :key="modelDate ? modelDate.toString() : null"
  >
    <template v-slot:activator="{ on }">
      <MaskedTextField
        :inputData.sync="maskedModelDate"
        :mask-type="pickerType"
        :label="label"
        v-bind="$attrs"
        @update:inputData="setModelDate"
        @blur="lostFocus"
      >
        <template slot="prependMask">
          <v-icon v-on="on">mdi-calendar</v-icon>
        </template>

        <template v-if="hasTodayButton" slot="appendMask">
          <v-icon @click="setToday">mdi-bookmark</v-icon>
        </template>
      </MaskedTextField>

      <!-- <v-text-field
        :value="modelDate | formatDate"
        :label="label"

        v-bind="$attrs"
      >
        <template v-slot:prepend>
          <v-icon v-on="on">mdi-calendar</v-icon>
        </template>
      </v-text-field> -->
    </template>
    <v-date-picker
      v-model="modelDate"
      @change="change"
      locale="pt-br"
      :type="pickerType"
    />
  </v-menu>
</template>

<script>
import moment from "moment";
import MaskedTextField from "@shared_components/masked_text_field.vue"

 export default {
  data () {
   return {
     dateMenu: false,
     modelDate: null,
     maskedModelDate: null,
   }
  },
  components: {
    MaskedTextField: MaskedTextField,
  },
  props: {
    hasBlur: {
      type: Boolean,
      default: true,
    },
    inputData: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: "Data"
    },
    pickerType: {
      type: String,
      default: "date"
    },
    hasTodayDate: {
      type: Boolean,
      default: false
    },
    hasTodayButton: {
      type: Boolean,
      default: false
    }
  },
  created() {
    if (this.hasTodayDate && !this.inputData) {
      this.setToday();
    } else {
      this.modelDate = this.inputData;
    }
    // console.log("this.modelDate", this.modelDate);
    if (this.pickerType == "month") {
      this.maskedModelDate = moment(this.modelDate).format("MM/YYYY");
    } else {
      this.maskedModelDate = moment(this.modelDate).format("DD/MM/YYYY");
    }
  },
  methods: {
    change: function () {
      this.dateMenu = false;
      if (this.pickerType == "month") {
        this.maskedModelDate = moment(this.modelDate).format("MM/YYYY");
      } else {
        this.maskedModelDate = moment(this.modelDate).format("DD/MM/YYYY");
      }
      // console.log("this.modelDate 2", this.modelDate, this.maskedModelDate);
      this.emitDateChange();
    },
    setModelDate: function() {
      if (this.pickerType == "month" && this.maskedModelDate.length == 6) {
        this.modelDate = moment(this.maskedModelDate, "MMYYYY").format("YYYY-MM");
        this.emitDateChange();
      } else if (this.pickerType == "date" && this.maskedModelDate.length == 8) {
        this.modelDate = moment(this.maskedModelDate, "DDMMYYYY").format("YYYY-MM-DD");
        this.emitDateChange();
      }
    },
    emitDateChange: function() {
      this.$emit('update:inputData', this.modelDate);
      this.$emit('change');
    },
    lostFocus: function(){
      if(this.blur){
      if ((this.pickerType == "month" && this.maskedModelDate.length < 6) || (this.pickerType == "date" && this.maskedModelDate.length < 8)) {
        this.maskedModelDate = "";
        this.modelDate = null;
        this.emitDateChange();
      }
      }
    },
    setToday: function() {
      if (this.pickerType == "month") {
        this.modelDate = moment().format('YYYY-MM');
      } else if (this.pickerType == "date") {
        this.modelDate = moment().format('YYYY-MM-DD');
      }
      
      this.change();
    }
  },
  // computed: {
  //   computedStartDateFormatted() {
  //     return this.startDate ? moment(this.startDate).format("DD/MM/YYYY") : "";
  //   },
  //   computedEndDateFormatted() {
  //     return this.endDate ? moment(this.endDate).format("DD/MM/YYYY") : "";
  //   }
  // }
 }
</script>

<style scoped>
</style>
